<template>
  <div>
    <SpFinder
      id="1"
      ref="finder"
      :url="{
        data: requestUrl
      }"
      title="数据"
      :columns="columns"
      :actions="actions"
      :search="[{ key: 'time', name: '', slot: 'time' }]"
      :hooks="{
        beforeSearch: beforeSearch
      }"
      @reset="onFinderResetGroup"
    >
      <template v-slot:time>
        <el-date-picker
          v-model="optionTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="changeOptionTime"
        />
      </template>
    </SpFinder>
  </div>
</template>
<script>
export default {
  data () {
    const columns = [
      {
        name: '操作时间',
        key: 'created_at'
      },
      {
        name: '操作人',
        key: 'create_user'
      },
      {
        name: 'IP地址',
        key: 'ip'
      }
    ]
    const actions = [
      {
        name: '详情',
        key: 'edit',
        type: 'button',
        action: {
          type: 'dialog',
          title: '操作日志',
          component: () => import('@/view/resource/redPages/optionsDetail.vue')
        }
      }
      // {
      //     name: '详情',
      //     key: 'detail',
      //     type: 'button',
      //     action: {
      //       type: 'link',
      //       path: (row, selections) => `/membership/membershipSopEdit?id=${row.id}` // 字符串方式跳转
      //     }
      //   },
    ]
    return {
      requestUrl: `${process.env.VUE_APP_BASE_API + '/setting/red-envelope-setting-logs'}`,
      columns,
      actions,
      optionTime: ''
    }
  },
  mounted () {},
  methods: {
    beforeSearch (params) {
      console.log('beforeSearch:', params)
      params['coupon_type'] = 'newbie'
      if (this.optionTime.length > 0) {
        params['start_time'] = this.optionTime[0]
        params['end_time'] = this.optionTime[1]
      }
      return params
    },
    changeOptionTime (e) {
      console.log(e)
      this.optionTime = e
    },
    onFinderResetGroup () {
      this.optionTime = []
      this.$refs.finder.refresh()
    }
  }
}
</script>
